import React from "react"
import { Flex, PinInput as ChakraPinInput } from "@chakra-ui/react"
import { IPinInputTypes } from "./PinInputTypes"

import { StyledPinInputField } from "./StyledPinInput"

export const PinInput: React.FC<IPinInputTypes> = ({
  fieldsQuantity,
  value,
  onChange,
  onComplete,
  isDisabled,
  pinInputFieldStyles,
}) => {
  const renderFields = () =>
    Array.from({ length: fieldsQuantity }, (_v, i: number) => (
      <StyledPinInputField key={i} {...pinInputFieldStyles} />
    ))

  return (
    <Flex justifyContent="space-between">
      <ChakraPinInput
        manageFocus
        value={value}
        onChange={onChange}
        placeholder={""}
        isDisabled={isDisabled}
        otp
        onComplete={onComplete}
      >
        {renderFields()}
      </ChakraPinInput>
    </Flex>
  )
}
export default PinInput
